// extracted by mini-css-extract-plugin
export default {"grid":"ProductList_grid__-MPr-","title":"ProductList_title__C9tFo","s-head":"ProductList_s-head__LSzr1"};